const AVAILABLE_ROLES = [
  { value: 'marketing', title: 'Marketing' },
  { value: 'humanResources', title: 'Human Resources' },
  { value: 'finance', title: 'Finance' },
  { value: 'operations', title: 'Operations' },
  { value: 'sales', title: 'Sales' },
  { value: 'accounting', title: 'Accounting' },
  { value: 'informationTechnology', title: 'Information Technology' },
  { value: 'customerService', title: 'Customer Service' },
  { value: 'strategy', title: 'Strategy' },
  { value: 'purchasing', title: 'Purchasing' },
  { value: 'production', title: 'Production' },
  { value: 'researchAndDevelopment', title: 'Research & Development' },
  { value: 'facilityManagement', title: 'Facility Management' },
  { value: 'security', title: 'Security' },
  { value: 'legal', title: 'Legal' },
  { value: 'logistics', title: 'Logistics' },
  { value: 'founder', title: 'Founder' },
  { value: 'other', title: 'Other' }
]

export { AVAILABLE_ROLES }
